import "./Footer.css";
import { Facebook } from "@mui/icons-material";
import { Instagram } from "@mui/icons-material";
import { LinkedIn } from "@mui/icons-material";
import React, { useContext, useEffect, useState } from "react";
import { Twitter } from "@mui/icons-material";
import { WhatsApp } from "@mui/icons-material";
import { YouTube } from "@mui/icons-material";
import logo from "../../../img/AIASA.png";
import iconLogo from "../../../img/IconLogo.png";
import FB from "../../../img/socialicons/facebook.png";
import INS from "../../../img/socialicons/insta.png";
import WHATS from "../../../img/socialicons/whastapp.png";
import TWITT from "../../../img/socialicons/Twit_Footer.png";
import LINKD from "../../../img/socialicons/linkedin.png";
import YOUTUBE from "../../../img/socialicons/youtube.png";
import TELEGRAM from "../../../img/socialicons/telegram.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/UserDetails";
import { AxiosInstance } from "../../../axios";
import { clearBookFilters } from "../../../redux/purchaseBookFilterSlice";
import { useDispatch } from "react-redux";

function Footer() {
  const menuList = JSON.parse(sessionStorage.getItem("menu_list")) || [];
  const location = useLocation();
  const [dropdownClicked, setDropdownClicked] = useState(false);
  const [sideOpen, setSideOpen] = useState(false);
  const { user, logout } = useContext(UserContext);
  const navigate = useNavigate();

  const handleLogo = () => {
    navigate("/");
  };
  // Gallery Access
  const hasGalleryAccess = user?.menu_list?.some((id) => id >= 49 && id <= 61);
  // get user id
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let role_id = null;
  let user_type = null;
  let staff_status = null;
  let menuData = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user?.user_id;
      role_id = user.role_id;
      user_type = user?.user_type;
      menuData = user.menu_list;
      staff_status = user.staff_status;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }
  const dispatch = useDispatch();
  const handleNav = (navItem, type) => {
    dispatch(clearBookFilters());
    navigate(`${navItem}`);
    // if (type === 0) {
    sessionStorage.setItem("stateRefreshs", true);
    localStorage.setItem("stateRefreshs", true);
    // }
    // if (type === 1) {
    sessionStorage.setItem("stateRefreshs_test", true);
    localStorage.setItem("stateRefreshs_test", true);
    // }
    // if (type === 3) {
    sessionStorage.setItem("stateRefreshs_spl", true);
    localStorage.setItem("stateRefreshs_spl", true);
    // }
    // if (type === 4) {
    sessionStorage.setItem("stateRefreshs_model", true);
    localStorage.setItem("stateRefreshs_model", true);
    // }
    // if (type === 5) {
    sessionStorage.setItem("stateRefreshs_mock", true);
    localStorage.setItem("stateRefreshs_mock", true);
    // }
    // if (type === 2) {
    sessionStorage.setItem("stateRefreshs_coun", true);
    localStorage.setItem("stateRefreshs_coun", true);
    // }
  };
  const ToggleOpen = (item) => {
    dispatch(clearBookFilters());
    navigate(item);
    setSideOpen(!sideOpen);
    const modal_close = document.querySelector("#MobileMenuClose");
    if (modal_close) {
      modal_close.click();
    }
    sessionStorage.setItem("stateRefreshs", true);
    localStorage.setItem("stateRefreshs", true);
    sessionStorage.setItem("stateRefreshs_test", true);
    localStorage.setItem("stateRefreshs_test", true);
    sessionStorage.setItem("stateRefreshs_spl", true);
    localStorage.setItem("stateRefreshs_spl", true);
    sessionStorage.setItem("stateRefreshs_model", true);
    localStorage.setItem("stateRefreshs_model", true);
    sessionStorage.setItem("stateRefreshs_mock", true);
    localStorage.setItem("stateRefreshs_mock", true);
    sessionStorage.setItem("stateRefreshs_coun", true);
    localStorage.setItem("stateRefreshs_coun", true);
  };
  const handleSocialIcons = (nam) => {
    if (nam === "Fac") {
      window.open(
        "https://www.facebook.com/annatnpsccenter?mibextid=ZbWKwL",
        "_blank"
      );
    } else if (nam === "You") {
      window.open("https://www.youtube.com/@ANNAIASACADEMY-KPM", "_blank");
    } else if (nam === "Tel") {
      window.open("https://t.me/annaiasacademy", "_blank");
    } else if (nam === "Ins") {
      window.open(
        "https://www.instagram.com/anna_ias_academy?igsh=MjNmc2M1ajYzaWhl&utm_source=qr",
        "_blank"
      );
    } else if (nam === "Wha") {
      window.open(
        "https://whatsapp.com/channel/0029VaBYURMIXnlmlHyKao1o",
        "_blank"
      );
    } else if (nam === "Lin") {
      window.open(
        "https://www.linkedin.com/in/anna-ias-academy-6880093a4",
        "_blank"
      );
    } else if (nam === "Twitt") {
      window.open("https://x.com/aiakpm1?s=21", "_blank");
    }
  };
  const [categories, setCategories] = useState([]);
  // New of Course content
  // Fetch categories from the API
  useEffect(() => {
    const fetchCategorie_list = async () => {
      try {
        const response = await AxiosInstance.get("api/course/category_list");
        if (response.data.status) {
          setCategories(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategorie_list();
  }, []);
  return (
    <footer className="text-center text-lg-start text-white pt-5">
      <div className="footerContainer">
        {/* <div className="row ">
          <div className="col-lg-7 col-md-12">
            <h4 className="footer_head_title ms-2">
              Sign up to our newsletter
            </h4>
            <div className="footer_sub_heading ms-2 text-md-center text-lg-start">
              Stay up to date with the latest news, announcements and articles
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div id="Border_Footer" className=""></div>
          </div>
        </div> */}

        <div className="row footerRow">
          <div className="col-xl-2 col-lg-12 text-center d-flex" id="LogoCont">
            <div className="rounded-circle shadow-1-strong d-flex align-items-center justify-content-center mb-4 mx-auto ">
              <img
                src={iconLogo}
                onClick={handleLogo}
                alt="anna_ias_logo"
                className="footer_logo"
                loading="anna_ias_logo"
              />
            </div>
          </div>
          <div className="col-lg-12 MobileBorder">
            <div id="Border_Footer" className="mt-0"></div>
          </div>
          <div className="col-xl-2 col-lg-4  col-md-4 col-sm-12 footer_category_list">
            <h6 className="fw-bold mb-4 footer_link_category">About us</h6>
            <p className="footer_list">
              {" "}
              <a
                href="/WhoWeAre"
                className="text-reset footer_link"
                style={{ textDecoration: "none" }}
              >
                Who We Are
              </a>
            </p>
            <p className="footer_list">
              <a
                href="/WhyChooseUs"
                className="text-reset footer_link"
                style={{ textDecoration: "none" }}
              >
                Why Choose Us
              </a>
            </p>
          </div>
          <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 footer_category_list">
            <h6 className="fw-bold mb-4 footer_link_category">About Course</h6>

            {categories?.map((category) => (
              <p className="footer_list" key={category.id}>
                <a
                  href="javascript:void(0)"
                  className="text-reset footer_link"
                  onClick={() =>
                    navigate(`/CourseContent/${category.name}/${category.id}`)
                  }
                >
                  {category.name}
                </a>
              </p>
            ))}
          </div>

          <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 footer_category_list">
            <h6 className="fw-bold mb-4 footer_link_category">Admission</h6>

            <p className="footer_list">
              <a
                href="javascript:void(0)"
                className="text-reset footer_link"
                onClick={() =>
                  handleNav(
                    user_type === 2
                      ? "/Admission/Course"
                      : user_type && user_type !== 2
                      ? "/ListViewStudentConfirm/0"
                      : "/login",
                    0
                  )
                }
              >
                Courses
              </a>
            </p>

            <p className="footer_list">
              <a
                href="javascript:void(0)"
                className="text-reset footer_link"
                onClick={() =>
                  handleNav(
                    user_type === 2
                      ? "/Admission/TestBatch"
                      : user_type && user_type !== 2
                      ? "/ListViewStudentConfirm/1"
                      : "/login",
                    1
                  )
                }
              >
                Test Batches
              </a>
            </p>

            <p className="footer_list">
              <a
                href="javascript:void(0)"
                className="text-reset footer_link"
                onClick={() =>
                  handleNav(
                    user_type === 2
                      ? "/Admission/SpecialClasses"
                      : user_type && user_type !== 2
                      ? "/ListViewStudentConfirm/3"
                      : "/login",
                    3
                  )
                }
              >
                Special Classes
              </a>
            </p>

            <p className="footer_list">
              <a
                href="javascript:void(0)"
                className="text-reset footer_link"
                onClick={() =>
                  handleNav(
                    user_type === 2
                      ? "/Admission/Modelexam"
                      : user_type && user_type !== 2
                      ? "/ListViewStudentConfirm/4"
                      : "/login",
                    4
                  )
                }
              >
                Model Exams
              </a>
            </p>

            <p className="footer_list">
              <a
                href="javascript:void(0)"
                className="text-reset footer_link"
                onClick={() =>
                  handleNav(
                    user_type !== 2
                      ? "/ListViewStudentConfirm/5"
                      : "/Admission/Mockinterview",
                    5
                  )
                }
              >
                Mock Interviews
              </a>
            </p>
          </div>

          <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 footer_category_list">
            <h6 className="fw-bold mb-4 footer_link_category">Resources</h6>

            <p className="footer_list">
              <a
                href="javascript:void(0)"
                className="text-reset footer_link"
                onClick={() => {
                  const studyMaterialIds = [
                    3, 4, 5, 6, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 25,
                    26, 27, 28, 29,
                  ];

                  const hasStudyAccess =
                    Array.isArray(user?.menu_list) &&
                    user.menu_list.some((id) => studyMaterialIds.includes(id));

                  let targetPath = "/StudyMaterial/Books"; // guest route

                  if (
                    user_type === 1 ||
                    user_type === 3 ||
                    user_type === 4 ||
                    user_type === 5 ||
                    hasStudyAccess
                  ) {
                    targetPath = "/studyMaterials/Books/list"; // internal route
                  }

                  handleNav(targetPath, 0);
                }}
              >
                Study Materials
              </a>
            </p>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-12 footer_category_list">
            <h6 className="fw-bold mb-4 footer_link_category">Gallery</h6>

            {/* === Images === */}
            <p className="footer_list">
              <a
                href="javascript:void(0)"
                className="text-reset footer_link"
                onClick={() =>
                  handleNav(
                    user_type !== 2 ? "/GalleryImages" : "/GalleryImages",
                    0
                  )
                }
              >
                Images
              </a>
            </p>

            {/* === Videos === */}
            <p className="footer_list">
              <a
                href="javascript:void(0)"
                className="text-reset footer_link"
                onClick={() =>
                  handleNav(
                    user_type !== 2 ? "/GalleryVideos" : "/GalleryVideos",
                    1
                  )
                }
              >
                Videos
              </a>
            </p>

            {/* === Slides (admin or gallery-access users only) === */}
            {user &&
              (user_type === 1 ||
                user?.menu_list?.some((id) => id >= 49 && id <= 61)) && (
                <p className="footer_list">
                  <a
                    href="javascript:void(0)"
                    className="text-reset footer_link"
                    onClick={() => handleNav("/ViewBannerAdmin")}
                  >
                    Slides
                  </a>
                </p>
              )}
          </div>

          <div className=" footer_category_list">
            <h6 className="fw-bold mb-4 footer_link_category">Help Center</h6>
            <p className="footer_list">
              <a
                href="/ContactUs"
                className="text-reset footer_link"
                style={{ textDecoration: "none" }}
              >
                Contact Us
              </a>
            </p>
            <p className="footer_list">
              <a
                href="/AdmissionTermsAndCondition"
                className="text-reset footer_link"
                style={{ textDecoration: "none" }}
              >
                Terms of Use
              </a>
            </p>
            <p className="footer_list">
              <a
                href="/ShippingPolicy"
                className="text-reset footer_link"
                style={{ textDecoration: "none" }}
              >
                Shipping Policy
              </a>
            </p>
            <p className="footer_list">
              <a
                href="/RefundAndCancellationPolicy"
                className="text-reset footer_link"
                style={{ textDecoration: "none" }}
              >
                Refund Policy
              </a>
            </p>
            <p className="footer_list">
              <a
                href="/AdmissionPrivacyPolicy"
                className="text-reset footer_link"
                style={{ textDecoration: "none" }}
              >
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div id="Border_Footer" className=""></div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-5 col-md-6">
            <div class="MobileIocns">
              <a href="" className="me-3 link-secondary">
                <img
                  src={FB}
                  alt="facebook"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Fac")}
                />
              </a>
              <a href="" className="me-3 link-secondary">
                <img
                  src={INS}
                  alt="insta"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Ins")}
                />
              </a>
              <a href="" className="me-3 link-secondary">
                <img
                  src={WHATS}
                  alt="whastapp"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Wha")}
                />
              </a>
              <a href="" className="me-3 link-secondary">
                <img
                  src={TWITT}
                  alt="Twitter"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Twitt")}
                />
              </a>
              <a href="" className="me-3 link-secondary">
                <img
                  src={LINKD}
                  alt="Linkedin"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Lin")}
                />
              </a>
              <a href="" className="me-3 link-secondary">
                <img
                  src={YOUTUBE}
                  alt="Youtube"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("You")}
                />
              </a>
              <a href="" className="me-3 link-secondary">
                <img
                  src={TELEGRAM}
                  alt="telegram"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Tel")}
                  style={{ width: "24px", height: "24px" }}
                />
              </a>
            </div>
          </div>
          <div className="col-lg-7 col-md-6">
            <div className="row d-lg-none d-xl-none d-md-none">
              <div className="col-lg-12">
                <div id="Border_Footer" className=""></div>
              </div>
            </div>
            <div className="footer_copy  mb-4">
              <span>
                Copyright © {new Date().getFullYear()} Anna IAS Academy.
                <span className=""> All rights reserved.</span>{" "}
                {/* <a href={"/AdmissionPrivacyPolicy"} className="footer_rights">
                  / Privacy /
                </a>
                <a
                  href={"/AdmissionTermsAndCondition"}
                  className="footer_rights"
                >
                  Terms of Use
                </a> */}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
